import { useMatch, useNavigate } from "react-router-dom";
import Select, { ActionMeta, SingleValue } from "react-select";
import i18n from "../../locales";

export type SelectOptionType = { label: string; value: string };

const OPTIONS = [
    { value: "ko", label: "KO-KR" },
    { value: "en", label: "EN-US" },
    { value: "ja", label: "JA-JP" },
];

const dot = () => ({
    alignItems: "center",
    display: "flex",
    ":before": {
        background: `url('data:image/svg+xml;base64,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')`,
        content: '" "',
        display: "block",
        marginRight: 8,
        height: 20,
        width: 20,
    },
});

interface LangSelectProps {
    language: string;
    onChangeLanguage: (value: string) => void;
}

export const LangSelect = (props: LangSelectProps) => {
    const { language, onChangeLanguage } = props;
    const navigate = useNavigate();

    const locale = window.location.pathname.slice(1).split("/")[0];
    const matchRoot = useMatch("/") || locale === "";
    const matchKr = useMatch("/kr") || locale === "kr";
    const matchJp = useMatch("/jp") || locale === "jp";

    const onChangeSelectLanguage = (
        newValue: SingleValue<SelectOptionType>,
        actionMeta: ActionMeta<SelectOptionType>
    ) => {
        if (newValue) {
            const language = newValue.value;
            i18n.changeLanguage(language);
            navigate(language === "ko" ? "kr" : language === "ja" ? "jp" : "en");
            onChangeLanguage(language);
        }
    };

    return (
        <Select
            name="lang"
            value={{
                value: language,
                label: matchRoot || matchKr ? "KO-KR" : matchJp ? "JA-JP" : "EN-US",
            }}
            options={OPTIONS}
            isSearchable={false}
            styles={{
                control: (styles) => ({
                    ...styles,
                    backgroundColor: "white",
                    borderColor: "#F3F3F3",
                    minWidth: 136,
                    minHeight: 42,
                    borderRadius: 6,
                    color: "#7A7A7A",
                }),
                option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                    return {
                        ...styles,
                        cursor: "pointer",

                        ":active": {
                            ...styles[":active"],
                        },
                    };
                },
                input: (styles) => ({ ...styles, ...dot() }),
                placeholder: (styles) => ({ ...styles, ...dot() }),
                singleValue: (styles, { data }) => ({
                    ...styles,
                    ...dot(),
                    color: "#7A7A7A",
                    fontWeight: 500,
                }),
                indicatorSeparator: () => ({ display: "none" }),
            }}
            onChange={onChangeSelectLanguage}
        />
    );
};
